//store.ts
import { firebaseReduce } from "./firebaseState/slice";
import {
  configureStore,
  getDefaultMiddleware,
  ThunkAction,
  Action,
} from "@reduxjs/toolkit";
import logger from "redux-logger";
import { RootState } from "./type";
import { sendMessageReduce }  from "./createMessage/slice";

const middleware = [
  ...getDefaultMiddleware({
    serializableCheck: false,
  }),
  logger,
];

export const store = configureStore({
  reducer: {
    auth: firebaseReduce,
    sendMessage: sendMessageReduce
  },
  middleware,
});

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
